import { render, staticRenderFns } from "./BlogLoader.vue?vue&type=template&id=6d5e42d6&scoped=true&"
import script from "./BlogLoader.vue?vue&type=script&lang=js&"
export * from "./BlogLoader.vue?vue&type=script&lang=js&"
import style0 from "./BlogLoader.vue?vue&type=style&index=0&id=6d5e42d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5e42d6",
  null
  
)

export default component.exports